<template>
	<el-row type="flex" justify="center" :gutter="20">
		<template v-if="!full_screen_loading">
			<el-col id="form-panel">
				<keep-alive>
					<router-view @hide-navigation="show_navigation = false" ref="form_panel"/>
				</keep-alive>
			</el-col>
			<el-col v-if="show_navigation" id="nav-panel">
				<form-navigation
				:form_name="form_name"
				:form_type="form_type"
				v-on:validate-form="validateForm"
				v-on:submit-application="submitApplication"
				/>
			</el-col>
		</template>
	</el-row>
</template>

<script>
import formNavigation from './Form-Navigation';

import { mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import createActivityDetector from 'activity-detector';
const activityDetector = createActivityDetector({ timeToIdle: 7200000 /* two hours */ , inactivityEvents: [] });

import './store/subscription'; // Vuex subscription for hot patches
import BootstrapVuexModuleMixin from '@/js/mixins/bootstrap-vuex-modules-mixin';

export default {
	mixins: [ BootstrapVuexModuleMixin ],
	components: {	formNavigation },
	props: ['form_type', 'form_name'],
	async created(){
		await this.initFormModules();
		try{
			const application = await this.pullApplication();
			if(application.type !== this.form_type) throw 'form type does not match';
			await this.mergeApplication(application);
			if(application.submitted_at !== null){
				this.$router.push('exit');
			}
			this.$store.dispatch('application/subscribeToChannel');
			this.full_screen_loading = false;
		} catch(error) {
			this.$notify.error({
				title: 'Unable to Retrieve Application',
				message: error
			});
		}
	},
	mounted(){
		activityDetector.on('idle', () => {
			this.unsubscribeFromChannel();
			this.$router.push({ name: 'timeout'})
		});
	},
	computed: {
		...mapFields(['full_screen_loading'])
	},
	data(){
		return {
			show_navigation: true
		}
	},
	methods: {
		...mapMutations('application', ['importState']),
		...mapActions('application', ['unsubscribeFromChannel', 'mergeApplication', 'pullApplication']),
		validateForm(){
			this.$refs.form_panel.validateForm();
		},
		submitApplication(){
			const agreement_is_valid = this.$refs.form_panel.validateForm('agreement');
			if(agreement_is_valid){
				this.$refs.form_panel.saveAgreement(this.active_form_index)
			}
		}
	}
}
</script>
